var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{ref:"myVideo",attrs:{"controls":"","width":"100%","height":"100%","poster":_vm.poster,"disablePictureInPicture":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }